module.exports = __webpack_public_path__ + "static/media/pompasola-360-preview.a9951ed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/pompasola-360-preview.jpg
// module id = 1165
// module chunks = 0